import * as React from 'react';
import { FrownOutlined, MehOutlined } from '@ant-design/icons';
import { antGrey } from '../styles/globalStyles';

import Layout from 'antd/lib/layout';
import Text from 'antd/lib/typography/Text';
import Result from 'antd/lib/result';
import { BuildDistroEntityError } from '../../types';
import Space from 'antd/lib/space';
import TooltipInfoIcon from '../helperComponents/TooltipInfoIcon';

export interface BuildDistroEntityErrorResultProps {
    errorType: BuildDistroEntityError;
}

const titleByErrorType = (errorType: BuildDistroEntityError) => {
    switch (errorType) {
        case BuildDistroEntityError.BucketNotFound:
            return 'Bucket not found';
        case BuildDistroEntityError.NotABucketMember:
            return 'Not a bucket member';
        case BuildDistroEntityError.BuildNotFound:
            return 'Build not found';
        case BuildDistroEntityError.BuildNotSharedWithYou:
            return 'Build not shared with you';
    }
};

const iconByErrorType = (errorType: BuildDistroEntityError) => {
    switch (errorType) {
        case BuildDistroEntityError.BuildNotFound:
        case BuildDistroEntityError.BucketNotFound:
            return (
                <FrownOutlined
                    style={{
                        color: antGrey.grey5,
                    }}
                />
            );
        case BuildDistroEntityError.BuildNotSharedWithYou:
        case BuildDistroEntityError.NotABucketMember:
            return (
                <MehOutlined
                    style={{
                        color: antGrey.grey5,
                    }}
                />
            );
    }
};

const subtitleByErrorType = (errorType: BuildDistroEntityError) => {
    switch (errorType) {
        case BuildDistroEntityError.BucketNotFound:
            return 'The bucket you are looking for does not exist.';
        case BuildDistroEntityError.NotABucketMember:
            return 'You will need to be granted access before you can view this bucket.';
        case BuildDistroEntityError.BuildNotFound:
            return 'The build you are looking for does not exist.';
        case BuildDistroEntityError.BuildNotSharedWithYou:
            return 'You’ll need to be granted access before you can view or install this build.';
    }
};

const extraByErrorType = (errorType: BuildDistroEntityError) => {
    switch (errorType) {
        case BuildDistroEntityError.BuildNotSharedWithYou:
            return (
                <Space>
                    <Text
                        style={{
                            color: antGrey.grey7,
                        }}
                    >
                        Request access from a bucket admin
                    </Text>
                    {/* TODO: Better copy here? what should the tooltip say? */}
                    <TooltipInfoIcon tooltipContent={'The build must be shared with you by a bucket admin.'} />
                </Space>
            );
        case BuildDistroEntityError.NotABucketMember:
            return (
                <Space>
                    <Text
                        style={{
                            color: antGrey.grey7,
                        }}
                    >
                        Request access from a bucket admin
                    </Text>
                    {/* TODO: Better copy here? what should the tooltip say? */}
                    <TooltipInfoIcon
                        tooltipContent={"The bucket admin will need to add you to the bucket's member list."}
                    />
                </Space>
            );
        default:
            return null;
    }
};

export const BuildDistroEntityErrorResult: React.FC<React.PropsWithChildren<BuildDistroEntityErrorResultProps>> = ({
    errorType,
    children,
}) => {
    if (!Object.values(BuildDistroEntityError).includes(errorType)) {
        return <>{children}</>;
    }

    return (
        <Layout style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Result
                title={titleByErrorType(errorType)}
                icon={iconByErrorType(errorType)}
                subTitle={subtitleByErrorType(errorType)}
                extra={extraByErrorType(errorType)}
            />
        </Layout>
    );
};
